export default __webpack_public_path__ + "static/user2-282ee3a2022811f0b2b2efd2cfa34227.png";